module.exports = __webpack_public_path__ + "img/86.90c1fae7.jpg";